"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (_ref, ref) => {
  let {
    fillColor = _designTokens.ursaColors.blue400,
    emptyFillColor = _designTokens.ursaColors.neutral200,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20V4C19 3.44772 19.4477 3 20 3Z",
    fill: props.value >= 4 ? fillColor : emptyFillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.10256C15.0523 7.10256 15.5 7.55028 15.5 8.10256V20C15.5 20.5523 15.0523 21 14.5 21C13.9477 21 13.5 20.5523 13.5 20V8.10256C13.5 7.55028 13.9477 7.10256 14.5 7.10256Z",
    fill: props.value >= 3 ? fillColor : emptyFillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.6154C10.0523 11.6154 10.5 12.0631 10.5 12.6154V20C10.5 20.5523 10.0523 21 9.5 21C8.94772 21 8.5 20.5523 8.5 20V12.6154C8.5 12.0631 8.94772 11.6154 9.5 11.6154Z",
    fill: props.value >= 2 ? fillColor : emptyFillColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14.8974C4.55228 14.8974 5 15.3451 5 15.8974V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V15.8974C3 15.3451 3.44772 14.8974 4 14.8974Z",
    fill: props.value >= 1 ? fillColor : emptyFillColor
  }));
};
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SignalBarsIcon24.js.map